import "./LawnMowerServicingRepairsInCarlisleCumbria.module.css";
import Header from "@/reusable_sections/Header";
import HeroLawnMowerService from "./sections/HeroLawnMowerService";
import WhyChooseOurService from "./sections/WhyChooseOurService";
import OurServiceOfferings from "./sections/OurServiceOfferings";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import GetYourLawnMowerServicedToday from "./sections/GetYourLawnMowerServicedToday";
import Footer from "@/reusable_sections/Footer";
import Landscaping from "./sections/Landscaping";
export default function LawnMowerServicingRepairsInCarlisleCumbriaPage() {
  return <div>
      <Header />
      <HeroLawnMowerService />
      <Landscaping />
      <WhyChooseOurService />
      <OurServiceOfferings />
      <CustomerTestimonials />
      <GetYourLawnMowerServicedToday />
      <Footer />
    </div>;
}